import { isValidTwitterUrl } from '@vimily/bonjoro-ui-components-v2/Twitter';
import { isValidYoutubeUrl } from '@vimily/bonjoro-ui-components-v2/Youtube';
export const socialsUrl = '/socials';

export enum SocialType {
  Twitter = 'twitter',
  Youtube = 'youtube',
}

export enum SocialTab {
  All = 'all',
  Twitter = 'twitter',
  Youtube = 'youtube',
}

export interface SocialTypeDetails {
  iconUrl: string;
  label: string;
  entity: string;
  tab: SocialTab;
}

export const socials: Record<SocialType, SocialTypeDetails> = {
  [SocialType.Twitter]: {
    iconUrl: 'https://cdn.bonjoro.com/assets/Flat-icons/twitter-x-black.png',
    label: 'Twitter',
    entity: 'Tweet',
    tab: SocialTab.Twitter,
  },
  [SocialType.Youtube]: {
    iconUrl: 'https://cdn.bonjoro.com/assets/icons/youtube.svg',
    label: 'YouTube',
    entity: 'Video',
    tab: SocialTab.Youtube,
  },
};

export const excludedSocials = [SocialType.Twitter];

export const availableSocials: Record<SocialType, SocialTypeDetails> = Object.fromEntries(
  Object.entries(socials).filter(([type]) => !excludedSocials.includes(type as SocialType))
) as Record<SocialType, SocialTypeDetails>;

export const isValidSocialUrl = (url: string, type: SocialType) => {
  if (!url) return false;

  switch (type) {
    case SocialType.Youtube:
      return isValidYoutubeUrl(url);
    case SocialType.Twitter:
    default:
      return isValidTwitterUrl(url);
  }
};
